import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ApiError } from "./lib/fetchJson";
// NUR diese zwei Stildateien, in dieser Reihenfolge, und nur hier:
// index.css bindet tokens.css VOR base.css ein (base.css benutzt die
// Variablen, die tokens.css setzt), app.css ergänzt danach die Schale.
import "./styles/index.css";
import "./styles/app.css";
import { App } from "./App";

// Genau die Vorgaben aus SPEC §5.4.2 — an EINER Stelle, nicht je Aufruf.
// `retry` wiederholt nur, was sich durch Wiederholen heilen lässt: ein 4xx
// bleibt ein 4xx, und drei Versuche darauf sind drei Fehlermeldungen.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: (n: number, e: unknown) => n < 2 && !(e instanceof ApiError && e.status >= 400 && e.status < 500),
    },
  },
});

const wurzel = document.getElementById("root");
if (!wurzel) throw new Error("Kein #root im Dokument — index.html wurde verändert.");

// Der QueryClientProvider gehört HIERHER und nirgends sonst: Planliste,
// Vorlagen, Stände, Ferien und Verwaltung rufen `useQuery`; ohne den Provider
// wirft der ERSTE dieser Aufrufe „No QueryClient set" und die Startseite ist
// nach der Anmeldung eine weiße Fläche im ScreenBoundary (R-01).
createRoot(wurzel).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </StrictMode>,
);
